export const TAP_DURATION_MS = 110
export const TAP_MOVEMENT_PX = 9 // max movement during the tap, keep it small

export const SWIPE_MIN_DURATION_MS = 111
export const SWIPE_MIN_DISTANCE_PX = 20
